const de = {
  "lang.switch": "Sprache wählen",
  "gallery.title": "Impressionen",
  "gallery.enlarge": "{alt} vergrößern",
  "gallery.close": "Galerie schließen",
  "gallery.prev": "Vorheriges Bild",
  "gallery.next": "Nächstes Bild",
  "gallery.left.alt": "Leonardo Hotel Nikolai links",
  "gallery.middle.alt": "Leonardo Hotel Nikolai mittig",
  "gallery.right.alt": "Leonardo Hotel Nikolai rechts",
  "gallery.a.alt": "Dr. Hoffmann Massage im Leonardo Hotel Nikolai",
  "gallery.b.alt": "Hotelmassage im Leonardo Hotel Nikolai",
  "gallery.c.alt": "Regeneration im Leonardo Hotel Nikolai",
  "page.title": "Wählen Sie Ihre {em}Massage{/em}",
  "page.intro":
    "Buchen Sie Ihre Massage direkt über das Hotel-Tablet.",
  "page.introHighlight": "Wir kommen zu Ihnen!",
  "page.introHours": "Termine sind täglich zwischen 10:00 und 22:00 Uhr verfügbar.",
  "testimonials.kicker": "Stimmen aus dem Nikolai",
  "testimonials.title": "Kurz gebucht. Spürbar leichter.",
  "testimonials.verified": "Verifizierte Buchung",
  "testimonials.service.wakeup": "Wake-Up Massage",
  "testimonials.service.classic": "Classic Massage",
  "testimonials.0.name": "Marie K.",
  "testimonials.0.quote":
    "Fünf Minuten, die sich nach einem echten Neustart angefühlt haben. Perfekt vor dem Abendtermin.",
  "testimonials.1.name": "Jonas R.",
  "testimonials.1.quote":
    "Direkt im Hotel gebucht und kurz darauf wieder wach im Kopf. Genau richtig nach der Anreise.",
  "testimonials.2.name": "Claudia M.",
  "testimonials.2.quote":
    "Die Classic Massage war ruhig, präzise und wohltuend. Danach waren Nacken und Schultern frei.",
  "testimonials.3.name": "Nina S.",
  "testimonials.3.quote":
    "Ich wollte nur kurz neue Energie. Die Wake-Up Massage hat genau das geliefert.",
  "testimonials.4.name": "Thomas B.",
  "testimonials.4.quote":
    "Sehr professionell und angenehm. Die 15 Minuten Classic waren ideal zwischen zwei Terminen.",
  "testimonials.5.name": "Elena W.",
  "testimonials.5.quote":
    "Unkompliziert, freundlich und überraschend effektiv. Ich würde Wake-Up sofort wieder buchen.",
  "testimonials.6.name": "Robert H.",
  "testimonials.6.quote":
    "Classic war die richtige Wahl nach einem langen Reisetag. Ruhig, sauber, sehr erholsam.",
  "testimonials.7.name": "Amelie T.",
  "testimonials.7.quote":
    "Die kurze Aktivierung hat meinen Tag gerettet. Schnell gebucht, pünktlich, sehr sympathisch.",
  "master.kicker": "Ein Wort von unserem Master Sura",
  "master.title": "Regeneration darf leicht sein.",
  "master.quote":
    "Mein Ziel ist, dass Hotelgäste in wenigen Minuten wieder freier atmen, leichter stehen und mit neuer Energie ihren Aufenthalt in Hamburg genießen können.",
  "master.name": "Master Sura · Dr. Hoffmann Massage",
  "master.alt": "Master Sura",
  "options.hotel-wakeup-5.title": "Wake-Up Massage",
  "options.hotel-wakeup-5.subtitle": "Energie in wenigen Minuten",
  "options.hotel-wakeup-5.priceNote": "p. P.",
  "options.hotel-wakeup-5.description":
    "Unsere Wake-up-Massage ist die schnelle 4-in-1-Aktivierung für deinen Körper. Sie fördert die Durchblutung, löst Verspannungen, unterstützt die Regeneration und verbessert die Beweglichkeit. Ideal, wenn du schnell neue Energie brauchst.",
  "options.hotel-quick-15.title": "Classic Massage",
  "options.hotel-quick-15.subtitle": "Ganzkörper-Erholung für die Woche",
  "options.hotel-quick-15.priceNote": "15 Min.",
  "options.hotel-quick-15.description":
    "Unsere Classic-Massage ist die gezielte Ganzkörpermassage für nachhaltige Erholung und neue Energie. Mit der perkussiven Massage werden Verspannungen und Verklebungen im gesamten Körper intensiv bearbeitet, die Durchblutung gefördert und die Regeneration unterstützt. Nach einer kurzen Erholungsphase fühlt sich der Körper wieder freier, beweglicher und voller Energie an – ideal für einen ausgeglichenen Energiefluss durch die ganze Woche.",
  "options.hotel-performance-60.title": "Intense",
  "options.hotel-performance-60.subtitle": "Energie für dein Leben!",
  "options.hotel-performance-60.priceNote": "60 Min.",
  "options.hotel-performance-60.description":
    "Für Gäste, die gezielt trainieren, mobilisieren oder entspannen möchten. Auf Wunsch auch als begleitete Session in einem Fitnessstudio ihrer Wahl.",
  "option.select": "Termin Auswählen",
  "option.selected": "Auswahl aktiv",
  "step.dateTime": "{title} — {em}Datum & Uhrzeit{/em}",
  "step.details": "Ihre {em}Angaben{/em}",
  "step.payment": "{em}Zahlung{/em}",
  "step.booking": "Ihre {em}Buchung{/em}",
  "calendar.prev": "← Zurück",
  "calendar.next": "Weiter →",
  "calendar.closedDay": "Nicht buchbar",
  "calendar.closedWeekend": "Samstag und Sonntag nicht buchbar",
  "slots.loading": "Verfügbare Zeiten werden geladen…",
  "slots.none":
    "Heute sind keine passenden Termine mehr verfügbar. Bitte wählen Sie einen späteren Zeitpunkt.",
  "slots.error.leadTime": "Bitte wählen Sie einen Termin mit mindestens {minutes} Minuten Vorlauf.",
  "slots.error.hours": "Bitte wählen Sie eine Startzeit zwischen 10:00 und 22:00 Uhr.",
  "slots.error.generic":
    "Wir konnten keine passenden Termine laden. Bitte wählen Sie einen späteren Zeitpunkt.",
  "details.summary":
    "Bitte gib deine Kontaktdaten und den Besuchsort an, damit wir dir die Bestätigung senden können.",
  "form.firstName": "Vorname *",
  "form.lastName": "Nachname *",
  "form.email": "E-Mail *",
  "form.firstNamePlaceholder": "z. B. Max",
  "form.lastNamePlaceholder": "z. B. Mustermann",
  "form.emailPlaceholder": "name@beispiel.de",
  "form.phone": "Telefonnummer *",
  "form.visitLocation": "Wo dürfen wir Sie besuchen?",
  "form.visitLocation.hotel": "Im Hotelzimmer",
  "form.visitLocation.wellness": "Im Wellness-Bereich",
  "form.floor": "Stockwerk *",
  "form.room": "Zimmernummer *",
  "form.notes": "Hinweise (optional)",
  "form.phonePlaceholder": "+49 ...",
  "form.floorPlaceholder": "z. B. 4",
  "form.roomPlaceholder": "z. B. 412",
  "form.notesPlaceholder": "Klingelschild, besondere Wünsche…",
  "payment.summary":
    "Wählen Sie, ob Sie online oder vor Ort beim Termin bezahlen möchten.",
  "payment.onSite.title": "Vor Ort bezahlen",
  "payment.onSite.desc": "Bar oder Karte beim Termin in Ihrem Zimmer.",
  "payment.online.title": "Online bezahlen",
  "payment.online.desc": "Nach dem Bestätigen leitet Sie Stripe zur Zahlung weiter.",
  "summary.service": "Leistung",
  "summary.duration": "Dauer",
  "summary.date": "Datum",
  "summary.time": "Uhrzeit",
  "summary.name": "Name",
  "summary.email": "E-Mail",
  "summary.visitLocation": "Besuchsort",
  "summary.floor": "Stockwerk",
  "summary.room": "Zimmer",
  "summary.payment": "Zahlung",
  "summary.total": "Gesamt",
  "summary.durationValue": "{minutes} Min.",
  "summary.paymentOnline": "Online",
  "summary.paymentOnSite": "Vor Ort",
  "summary.empty": "—",
  "verify.title": "E-Mail-Bestätigung erforderlich",
  "verify.body":
    "Sie können den Termin jetzt vormerken. Erst nach der Bestätigung Ihrer E-Mail-Adresse (Link im Postfach) wird die Buchung verbindlich und unser Team informiert. Ohne Bestätigung findet der Termin nicht statt.",
  "auth.body":
    "Für die Buchung benötigen Sie ein Konto. Ihre Angaben bleiben gespeichert, wenn Sie sich anmelden oder registrieren. Nach der Registrierung können Sie sofort buchen; die E-Mail-Bestätigung macht den Termin erst verbindlich.",
  "auth.login": "Anmelden",
  "auth.register": "Kostenlos registrieren",
  "submit.processing": "Buchung läuft…",
  "submit.pay": "Zur Zahlung",
  "submit.reserve": "Termin vormerken",
  "submit.confirm": "Jetzt verbindlich buchen",
  "submit.guest": "Buchung abschließen",
  "error.pickSlot": "Bitte wählen Sie einen Termin aus.",
  "error.completeName":
    "Bitte vervollständigen Sie zuerst Ihr Konto mit Vor- und Nachnamen.",
  "error.firstName": "Bitte gib deinen Vornamen an.",
  "error.lastName": "Bitte gib deinen Nachnamen an.",
  "error.email": "Bitte gib deine E-Mail-Adresse an.",
  "error.emailInvalid": "Bitte gib eine gültige E-Mail-Adresse an.",
  "error.floor": "Bitte geben Sie Ihr Stockwerk an.",
  "error.room": "Bitte geben Sie Ihre Zimmernummer an.",
  "error.phone":
    "Bitte geben Sie eine Telefonnummer an, damit wir Sie bei Bedarf erreichen können.",
  "error.loginRequired":
    "Bitte melden Sie sich an oder registrieren Sie sich, um die Buchung abzuschließen.",
  "error.checkout": "Zahlungsseite konnte nicht geöffnet werden.",
  "error.bookingFailed": "Die Buchung konnte nicht angelegt werden.",
  "shell.nav.home": "Startseite",
  "shell.nav.concept": "Konzept",
  "shell.nav.license": "Lizenzmodell",
  "shell.nav.career": "Karriere",
  "shell.nav.pricing": "Tarife",
  "shell.nav.contact": "Kontakt",
  "shell.nav.events": "Events",
  "shell.nav.admin": "Admin",
  "shell.nav.bookCta": "Jetzt Termin buchen",
  "shell.nav.shop": "Shop",
  "shell.nav.referral": "Empfehlen",
  "shell.nav.accountMenu": "Kontomenü öffnen",
  "shell.nav.myAccount": "Mein Konto",
  "shell.nav.myAppointments": "Meine Termine",
  "shell.nav.vouchers": "Gutscheine",
  "shell.nav.referFriends": "Freunde empfehlen",
  "shell.nav.logout": "Abmelden",
  "shell.nav.loginMenu": "Login-Menü öffnen",
  "shell.nav.login": "Einloggen",
  "shell.nav.register": "Registrieren",
  "shell.nav.openMenu": "Menü öffnen",
  "shell.footer.offer": "Angebot",
  "shell.footer.book": "Termin buchen",
  "shell.footer.shop": "Gutscheine",
  "shell.footer.referral": "Empfehlen",
  "shell.footer.career": "Karriere",
  "shell.footer.partner": "Lizenzpartner werden",
  "shell.footer.pricing": "Tarife",
  "shell.footer.promo": "Juni-Aktion",
  "shell.footer.account": "Konto",
  "shell.footer.login": "Einloggen",
  "shell.footer.register": "Registrieren",
  "shell.footer.myAccount": "Mein Konto",
  "shell.footer.contact": "Kontakt",
  "shell.footer.rights": "Alle Rechte vorbehalten",
  "shell.footer.imprint": "Impressum",
  "shell.footer.privacy": "Datenschutz",
  "shell.auth.login.kicker": "Einloggen",
  "shell.auth.login.title": "Willkommen {em}zurück{/em}",
  "shell.auth.login.lead":
    "Melde dich an, um Studio- und Vor-Ort-Termine zu buchen oder deine bestehenden Buchungen zu verwalten.",
  "shell.auth.login.email": "E-Mail",
  "shell.auth.login.password": "Passwort",
  "shell.auth.login.submitting": "Anmelden...",
  "shell.auth.login.submit": "Anmelden",
  "shell.auth.login.noAccount": "Noch kein Konto?",
  "shell.auth.login.registerLink": "Jetzt registrieren →",
  "shell.auth.login.forgotPassword": "Passwort vergessen?",
  "shell.auth.login.failed": "Login fehlgeschlagen.",
  "shell.auth.register.kicker": "Konto erstellen",
  "shell.auth.register.title": "Neues {em}Konto{/em}",
  "shell.auth.register.lead":
    "Registriere dich, um Studio- und Vor-Ort-Termine zu buchen, Buchungen zu verwalten und Erinnerungen per E-Mail zu erhalten.",
  "shell.auth.register.firstName": "Vorname",
  "shell.auth.register.lastName": "Nachname",
  "shell.auth.register.email": "E-Mail",
  "shell.auth.register.phone": "Telefonnummer (optional)",
  "shell.auth.register.phonePlaceholder": "+49 ...",
  "shell.auth.register.address": "Massageadresse (optional)",
  "shell.auth.register.addressPlaceholder": "Straße, Hausnummer, PLZ und Ort",
  "shell.auth.register.invoiceAddress": "Rechnungsadresse (optional)",
  "shell.auth.register.invoiceCompany": "Unternehmensname (optional)",
  "shell.auth.register.invoiceStreet": "Straße & Hausnummer",
  "shell.auth.register.invoicePostalCode": "PLZ",
  "shell.auth.register.invoiceCity": "Ort",
  "shell.auth.register.password": "Passwort",
  "shell.auth.register.passwordConfirm": "Passwort wiederholen",
  "shell.auth.register.privacyPrefix": "Ich habe die",
  "shell.auth.register.privacyLink": "Datenschutzhinweise",
  "shell.auth.register.privacySuffix":
    "gelesen und stimme der Verarbeitung meiner Daten zur Terminbuchung zu.",
  "shell.auth.register.agbPrefix": "Ich habe die",
  "shell.auth.register.agbLink": "AGB",
  "shell.auth.register.agbSuffix": "gelesen und akzeptiere sie.",
  "shell.auth.register.submitting": "Registrieren...",
  "shell.auth.register.submit": "Konto anlegen",
  "shell.auth.register.hasAccount": "Bereits registriert?",
  "shell.auth.register.loginLink": "Jetzt anmelden →",
  "shell.auth.register.passwordMismatch": "Die Passwörter stimmen nicht überein.",
  "shell.auth.register.acceptTerms": "Bitte akzeptiere die Datenschutzhinweise.",
  "shell.auth.register.acceptAgb": "Bitte akzeptiere die AGB.",
  "shell.auth.register.failed": "Registrierung fehlgeschlagen.",
  "shell.auth.register.verifyEmail": "Bitte bestätige deine E-Mail-Adresse.",
  "shell.auth.register.verifyEmailTitle": "E-Mail bestätigen",
  "shell.auth.register.verifyEmailHint":
    "Wir haben dir einen Bestätigungslink geschickt. Bitte öffne dein Postfach und klicke auf den Link, um dein Konto zu aktivieren.",
  "shell.auth.register.verifyEmailOk": "Verstanden",
  "shell.auth.register.name.firstRequired": "Bitte gib deinen Vornamen an.",
  "shell.auth.register.name.firstShort": "Der Vorname muss mindestens 2 Zeichen lang sein.",
  "shell.auth.register.name.firstLong": "Der Vorname darf höchstens 50 Zeichen lang sein.",
  "shell.auth.register.name.lastRequired": "Bitte gib deinen Nachnamen an.",
  "shell.auth.register.name.lastShort": "Der Nachname muss mindestens 2 Zeichen lang sein.",
  "shell.auth.register.name.lastLong": "Der Nachname darf höchstens 50 Zeichen lang sein.",
  "shell.auth.register.stepOf": "Schritt {current} von {total}",
  "shell.auth.register.stepName.title": "Name",
  "shell.auth.register.stepName.lead": "",
  "shell.auth.register.stepContact.title": "Kontakt",
  "shell.auth.register.stepContact.lead": "",
  "shell.auth.register.stepPassword.title": "Passwort",
  "shell.auth.register.stepPassword.lead": "Mind. 8 Zeichen",
  "shell.auth.register.stepTerms.title": "Zustimmung",
  "shell.auth.register.stepTerms.lead": "",
  "shell.auth.register.next": "Weiter",
  "shell.auth.register.back": "Zurück",
  "shell.auth.register.emailRequired": "Bitte gib deine E-Mail-Adresse an.",
  "shell.auth.register.emailInvalid": "Bitte gib eine gültige E-Mail-Adresse an.",
  "shell.auth.register.passwordShort": "Das Passwort muss mindestens 8 Zeichen lang sein.",
  "success.title": "Vielen {em}Dank!{/em}",
  "success.confirmingPayment":
    "Ihre Zahlung wird bestätigt — gleich ist Ihr Termin fest gebucht.",
  "success.pendingEmail":
    "Ihr Termin ist vorgemerkt. Bitte bestätigen Sie Ihre E-Mail-Adresse über den Link in Ihrem Postfach. Erst danach wird die Buchung verbindlich und unser Team informiert.",
  "success.pendingEmployee":
    "Deine Buchungsanfrage ist eingegangen und wartet auf die Bestätigung durch unser Team. Sie erhalten eine weitere E-Mail, sobald der Termin bestätigt ist.",
  "success.confirmed": "Deine Buchung ist bestätigt. Eine E-Mail mit allen Details ist unterwegs.",
  "success.failed": "Die Buchung konnte nicht abgeschlossen werden.",
  "success.verifyHint":
    "Ohne E-Mail-Bestätigung findet der Termin nicht statt. Prüfen Sie auch Ihren Spam-Ordner.",
  "success.paymentPending":
    "Die Zahlung wird noch bestätigt. Bitte prüfen Sie in ein paar Minuten Ihr Konto oder kontaktieren Sie uns.",
  "success.notFound": "Buchung nicht gefunden.",
  "success.service": "Leistung",
  "success.duration": "Dauer",
  "success.durationValue": "{minutes} Min.",
  "success.persons": "Personen",
  "success.appointment": "Termin",
  "success.byArrangement": "Nach Vereinbarung",
  "success.name": "Name",
  "success.floor": "Stockwerk",
  "success.room": "Zimmer",
  "success.location": "Ort",
  "success.price": "Preis",
  "success.free": "Kostenfrei",
  "success.net": "Netto",
  "success.vat": "MwSt. 19 %",
  "success.gross": "Brutto",
  "success.status": "Status",
  "success.statusPending": "Wartet auf Bestätigung",
  "success.statusConfirmed": "Bestätigt",
  "success.payment": "Zahlung",
  "success.paymentPaidOnline": "Online (bezahlt)",
  "success.paymentFreeFirst": "Kostenfrei (Erstbesuch)",
  "success.paymentOnline": "Online",
  "success.paymentOnSite": "Vor Ort",
  "success.accountCta": "Zu meinem Konto",
  "success.moreOptions": "Weitere Optionen",
  "success.homeCta": "Zur Startseite",
  "success.backToLeonardo": "Zurück zur Buchung",
  "shell.auth.verify.kicker": "E-Mail-Bestätigung",
  "shell.auth.verify.title": "{em}Verifizierung{/em}",
  "shell.auth.verify.loading": "E-Mail-Adresse wird bestätigt...",
  "shell.auth.verify.loadingEmailChange": "Neue E-Mail-Adresse wird bestätigt...",
  "shell.auth.verify.success": "E-Mail-Adresse erfolgreich bestätigt.",
  "shell.auth.verify.successEmailChange": "Neue E-Mail-Adresse erfolgreich bestätigt.",
  "shell.auth.verify.successBooking":
    "E-Mail-Adresse bestätigt. Ihre vorgemerkte Buchung ist jetzt verbindlich — unser Team wurde informiert.",
  "shell.auth.verify.incomplete": "Der Bestätigungslink ist unvollständig.",
  "shell.auth.verify.invalid": "Der Bestätigungslink ist ungültig oder abgelaufen.",
  "shell.auth.verify.backToLogin": "Zurück zum Login",
  "shell.auth.verify.backToLeonardo": "Zurück zur Buchung",
};

export default de;
